import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';

function Topnavbar() {
  // use state to manage the navbar's visibility
  const [nav, setNav] = useState(false);

  // Toggle function to handle the navbar's display
  const handleNav = () => {
    setNav(!nav);
  };

  const topnavItems = [
    { id: 1, text: 'Home', link: '/' },
    { id: 2, text: 'Products', link: '/products' },
    { id: 3, text: 'Promotions', link: '/promotions' },
    { id: 4, text: 'Brands', link: '/brands' },
    { id: 5, text: 'Blog', link: '/blog' },
    { id: 6, text: 'Support', link: '/support' },
  ];

  // Get the current location using useLocation hook
  const location = useLocation();

  return (
    <nav className="bg-gray-200 p-4">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="text-xl font-semibold">React-shopify</Link>

        {/* Toggle icon for smaller devices */}
        <div onClick={handleNav} className="block lg:hidden">
          {nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
        </div>

        {/* Navigation for larger devices */}
        <div className="hidden lg:flex lg:items-center lg:w-auto" id="nav-content">
          <ul className="list-reset lg:flex justify-end items-center">
            {topnavItems.map((item) => (
              <li key={item.id} className="mr-6 font-bold">
                <Link
                  to={item.link}
                  className={`hover:text-gray-500 ${
                    location.pathname === item.link ? 'text-xl border-b-2 border-gray-500' : ''
                  }`}
                >
                  {item.text}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      <ul
        className={`${
          nav ? 'block' : 'hidden'
        } lg:hidden ease-in-out duration-500`}
      >
        {topnavItems.map((item) => (
          <li
            key={item.id}
            className={`block mt-4  cursor-pointer ${
              location.pathname === item.link ? 'border-b-2  border-gray-700' : ''
            }`}
          >
            <Link to={item.link} className="hover:text-black font-bold">{item.text}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Topnavbar;
